import * as React from 'react';

import { CurrentHotelStore } from 'stores/current-hotel-store';
import { MultiItemStore } from 'src/common/stores/multi-item-store';

import { readFromCachedFragment } from 'utils/read-from-cached-fragment';

import { gql, useApolloClient } from '@apollo/client';

export const CACHED_PROPERTY_OFFERS_MULTI_ITEM_FRAGMENT = gql`
  fragment ShoppingContextFragment on OfferDetails {
    shoppingContext {
      multiItem {
        id
      }
    }
  }
`;

export const useMultiItemCacheRead = (currentHotel?: CurrentHotelStore, multiItem?: MultiItemStore) => {
  const client = useApolloClient();
  const propertyOffers = readFromCachedFragment(
    client,
    `OfferDetails:${currentHotel?.hotelId}`,
    CACHED_PROPERTY_OFFERS_MULTI_ITEM_FRAGMENT
  );
  const id = propertyOffers?.shoppingContext?.multiItem?.id;

  React.useEffect(() => {
    if (id) {
      multiItem?.updateSessionId(id);
    }
  });
};
